import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IPositionBookPromiseLookupService } from "../IPositionBookPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class PositionBookPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.PositionBookImpl>
  implements IPositionBookPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getPositionBook(code: string): Promise<CubiqTS.PositionBookImpl>;
  abstract getAdaptedPositionBook(code: string): Promise<any>;
  abstract getUserDefaultPositionBook(): Promise<CubiqTS.PositionBookImpl>;
  abstract getAdaptedUserDefaultPositionBook(): Promise<any>;
  abstract getAdaptedPositionBooks(query: string): Promise<Array<any>>;
  abstract getPositionBooks(query: string): Promise<Array<CubiqTS.PositionBookImpl>>;
  abstract getPositionBooksForPairAndTradingGroup(
    base: string,
    nonBase: string,
    traderGroupId: number,
    vehicleCcy?: string,
  ): Promise<any>;
  abstract getPositionBooksForPairAndUserBranch(base: string, nonBase: string): Promise<Array<any>>;
  abstract getPositionBooksForPairAndBranch(
    base: string,
    nonBase: string,
    branchCd: string,
  ): Promise<Array<any>>;
}
